// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mj-1";
export var spinner = "_mj-0";